'use client';

import type { Dispatch, ReactNode } from 'react';
import { createContext, useContext, useReducer } from 'react';
import { initialRoot, rootReducer } from './reducers';
import type { AuditActions, AuditState } from './reducers/reducers.types';
export type ContextType = {
  state: AuditState;
  dispatch: Dispatch<AuditActions>;
};
export const AuditContext = createContext<ContextType | undefined>(undefined);
export function useAuditContext() {
  const context = useContext(AuditContext);
  if (!context) {
    throw new Error('Error in Annotations Context');
  }
  return context;
}
export const AuditProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(rootReducer, initialRoot);
  const contextValue: ContextType = {
    state,
    dispatch
  };
  return <AuditContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="AuditProvider" data-sentry-source-file="index.tsx">
      {children}
    </AuditContext.Provider>;
};